import type { FilterTypeLabels } from './types'

export const FILTER_TYPE_LABELS: FilterTypeLabels = {
  Text: 'Text',
  Video: 'Video',
  Audio: 'Audio',
  Poll: 'Poll',
  Image: 'Image',
}
